import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-helpbutton-reports-totalrequestabandonedvoice-card',
  templateUrl: './helpbutton-reports-totalrequestabandonedvoice-card.component.html',
  styleUrls: ['./helpbutton-reports-totalrequestabandonedvoice-card.component.scss']
})
export class HelpbuttonReportsTotalrequestabandonedvoiceCardComponent implements OnInit {

  @Input() value;

  constructor() { }

  ngOnInit() {
  }

}
